import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsBoost from 'highcharts/modules/boost';
import { IScatterGraph } from '../../../interfaces/charts/trader-advisor.interface';

@Component({
    selector: 'traderadvisor-scatter',
    templateUrl: './traderadvisor-scatter.component.html',
    styleUrls: ['./traderadvisor-scatter.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TraderadvisorScatterComponent implements OnChanges {
    @Input() public options: IScatterGraph;

	constructor() {
		HighchartsBoost(Highcharts);
		HighchartsMore(Highcharts);
	}

    ngOnChanges() {
        if(this.options) {
            Highcharts.chart('hc-scatter',
            {
                chart: {
                    type: 'scatter',
                    height: '300'
                },
                title: {
                    text: '',
                },
                lang: {
                    noData: 'Sem dados para exibir'
                },
                yAxis: {
                    title: {
                        text: '',
                        offset: 0,
                    },
                    labels: {
                        format: 'R$ {value:,.0f}'
                    },
                    gridLineWidth: 0,
                    plotLines: [{
                        color: '#FB4E82',
                        dashStyle: 'Dash',
                        width: 1,
                        value: this.options.medianLine.loss,
                        zIndex: 3
                    }],
                    plotBands: [{
                        from: this.options.medianBands.loss.from,
                        to: this.options.medianBands.loss.to,
                        color: '#FFEFF4',
                    }]
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        formatter: function() {
                            return Highcharts.dateFormat('%e/%m', +this.value);
                        }
                    },
                    tickInterval: 24 * 3600 * 1000,
                    startOnTick: true,
                    endOnTick: true,
                    gridLineColor: '#DDD',
                    gridLineWidth: 1,
                    gridLineDashStyle: 'ShortDash',
                    // categories: this.options.data.dates,
                },
                tooltip: {
                    formatter: function(){
                        return 'R$ ' + Highcharts.numberFormat(this.y,2,',','.');
                    }
                },
                series: [{
                    name: 'Perdas acima da sua média',
                    type: 'scatter',
                    color: '#F02733',
                    showInLegend: false,
                    data: this.mergeResults(),
                    marker: { radius: 4, symbol: 'circle' }
                    }]
            });
        }
    }

    public mergeResults() {
        if(this.options) {
            const merge = [];
            const timezone = 3 * 60 * 60 * 1000;
            for (let index = 0; index < Object.keys(this.options.data.dates).length; index++) {
                merge.push([
                        new Date(this.options.data.dates[index]).getTime() - timezone,
                        this.options.data.results[index],
                ]);
            }
            return merge;
        }
    }
}
